export class IndicatorReportRequestModel {
    constructor(
        public assessmentId: string,
        public assessmentIndicatorId: string,
        public assessmentStrategyId: string,
        public indicatorId: string,
        public strategyId: string,
    ) {
        this.assessmentId = assessmentId;
        this.assessmentIndicatorId = assessmentIndicatorId;
        this.assessmentStrategyId = assessmentStrategyId;
        this.indicatorId = indicatorId;
        this.strategyId = strategyId;
    }

    static init = () => new IndicatorReportRequestModel("", "", "", "", "");
}
